<template>
  <Box>
    <form class="dialog" onsubmit="return false">
      <div class="header has-bcc-background has-text-white">
        <span>Regenerate Report</span>
      </div>

      <div class="body">Are you sure you want to regenerate this report?</div>

      <div class="footer">
        <button class="button" style="margin-right: 10px" @click="closeDialog(null)">Cancel</button>
        <button class="button has-bcc-background has-text-white" type="submit" @click="() => closeDialog(true)">Regenerate</button>
      </div>
    </form>
  </Box>
</template>

<script setup>
import Box from './Box.vue'
import { closeDialog } from 'vue3-promise-dialog'
</script>

<style scoped lang="scss">
@import './dialog.scss';
</style>
